import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { Files } from '../StrokeIcons';

export type FileAttachmentProps = ComponentProps<'div'> & {
  url: string;
};

export function FileAttachment({ url, className }: FileAttachmentProps) {
  // Extract filename from URL
  const filename = url.split('/').pop() ?? 'Download file';

  return (
    <div className={cn('px-3.5 py-2.5', className)}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 text-sm text-blue-500 transition-colors hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300"
      >
        <Files.File02 className="size-4 shrink-0" />
        <span className="truncate">{filename}</span>
      </a>
    </div>
  );
}
